import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getFaqsForPath } from "./faqData";

const siteUrl = "https://allcanadavanlines.com";
const siteName = "All Canada Van Lines";
const defaultDescription =
  "Looking for trusted long-distance moving companies in Canada? Go Move Canada offers affordable long-distance moving services, transparent pricing, and reliable cross-country movers. Get your free quote today.";
const defaultKeywords =
  "moving company in Canada, moving services, movers in Canada, local movers, long distance movers";

const defaultSeo = {
  title: "Affordable Long-Distance Movers Canada | Go Move Canada",
  description: defaultDescription,
  keywords: defaultKeywords,
};

const pagesWithOwnMetaTags = ["/movers-in-vancouver"];

const servicePages = {
  "/": defaultSeo,
  "/Contact": {
    title: "Contact GO MOVE CANADA | Moving Company in Canada",
    description:
      "Contact GO MOVE CANADA for moving quotes, support, and booking help for local, long-distance, packing, storage, and junk removal services.",
    keywords:
      "contact moving company Canada, moving quote Canada, GO MOVE CANADA contact, movers phone number",
  },
  "/local-movers": {
    title: "Local Movers in Canada | GO MOVE CANADA",
    description:
      "Book dependable local movers in Canada for apartment, condo, home, and office moves with careful handling and professional support.",
    keywords:
      "local movers Canada, local moving company, residential movers Canada, office movers Canada",
  },
  "/long-distance-movers": {
    title: "Long Distance Movers in Canada | GO MOVE CANADA",
    description:
      "Plan a smooth long-distance move across Canada with professional movers, secure transportation, and support from quote to delivery.",
    keywords:
      "long distance movers Canada, cross country movers Canada, long distance moving company, interprovincial movers",
  },
  "/storage-services": {
    title: "Moving and Storage Services in Canada | GO MOVE CANADA",
    description:
      "Find secure storage services in Canada for household goods, office items, and moving transitions with flexible moving support.",
    keywords:
      "storage services Canada, moving and storage Canada, secure storage, storage movers Canada",
  },
  "/junk-removal": {
    title: "Junk Removal Services in Canada | GO MOVE CANADA",
    description:
      "Clear unwanted items before or after your move with reliable junk removal services for homes, apartments, offices, and cleanouts.",
    keywords:
      "junk removal Canada, moving junk removal, furniture removal, cleanout services Canada",
  },
  "/moving-supplier": {
    title: "Moving Supplies in Canada | GO MOVE CANADA",
    description:
      "Get moving supplies for packing, protecting, and transporting your belongings during local and long-distance moves in Canada.",
    keywords:
      "moving supplies Canada, moving boxes, packing supplies, moving materials Canada",
  },
  "/packaging-services": {
    title: "Packing Services in Canada | GO MOVE CANADA",
    description:
      "Protect your belongings with professional packing services for household goods, fragile items, office equipment, and moving day preparation.",
    keywords:
      "packing services Canada, professional packers, moving packing service, packing and moving Canada",
  },
  "/Aboutus": {
    title: "About GO MOVE CANADA | Trusted Canadian Movers",
    description:
      "Learn about GO MOVE CANADA and our moving services for local, long-distance, storage, packing, and relocation support across Canada.",
    keywords:
      "about GO MOVE CANADA, Canadian movers, trusted moving company Canada, moving services Canada",
  },
  "/about": {
    title: "About All Canada Van Lines | Moving Services Canada",
    description:
      "Learn about All Canada Van Lines, our Canada-wide moving support, service approach, and professional relocation solutions.",
    keywords:
      "All Canada Van Lines, about moving company, Canada movers, relocation company Canada",
  },
  "/privacyPolicy": {
    title: "Privacy Policy | GO MOVE CANADA",
    description:
      "Read the GO MOVE CANADA privacy policy to learn how customer information is collected, used, protected, and managed.",
    keywords:
      "GO MOVE CANADA privacy policy, moving company privacy, customer data policy",
  },
  "/CalenderForm": {
    title: "Schedule Your Move | GO MOVE CANADA",
    description:
      "Choose your moving date and continue your booking request with GO MOVE CANADA.",
    keywords: "schedule move Canada, moving date, book movers Canada",
  },
  "/PropertySelect": {
    title: "Select Property Type | GO MOVE CANADA",
    description:
      "Select your property type to help GO MOVE CANADA prepare the right moving quote and service plan.",
    keywords:
      "property moving quote, home movers Canada, apartment movers Canada",
  },
  "/Propertysize": {
    title: "Select Property Size | GO MOVE CANADA",
    description:
      "Tell GO MOVE CANADA your property size so we can estimate your moving needs more accurately.",
    keywords:
      "moving estimate, property size moving quote, Canada movers quote",
  },
  "/FinalForm": {
    title: "Complete Moving Quote | GO MOVE CANADA",
    description:
      "Complete your moving request and submit the details needed for a GO MOVE CANADA quote.",
    keywords:
      "moving quote form, complete moving request, Canada moving estimate",
  },
  "/thankyou": {
    title: "Thank You | GO MOVE CANADA",
    description:
      "Thank you for contacting GO MOVE CANADA. Our team will review your moving request and follow up soon.",
    keywords: "moving request submitted, thank you movers Canada",
  },
  "/thankyou2": {
    title: "Thank You | GO MOVE CANADA",
    description:
      "Your request has been received by GO MOVE CANADA. Our moving team will be in touch soon.",
    keywords: "moving quote submitted, GO MOVE CANADA thank you",
  },
  "/how_to_choose_moving_companies_for_stress-free_Move": {
    title: "How to Choose Moving Companies for a Stress-Free Move",
    description:
      "Learn how to compare moving companies, check reliability, review services, and choose the right movers for a stress-free move.",
    keywords:
      "how to choose moving company, stress-free move, moving company tips, reliable movers Canada",
  },
  "/best_long-distance_moving_companies_in_canada": {
    title: "Best Long-Distance Moving Companies in Canada",
    description:
      "Explore what makes a long-distance moving company reliable and how to choose the best movers for relocation across Canada.",
    keywords:
      "best long distance moving companies Canada, long distance movers, Canada relocation movers",
  },
  "/cheap_moving_companies_in_canada": {
    title: "Cheap Moving Companies in Canada | Moving Cost Guide",
    description:
      "Find tips for comparing cheap moving companies in Canada while keeping your belongings protected and your move organized.",
    keywords:
      "cheap moving companies Canada, affordable movers Canada, budget moving company, low cost movers",
  },
  "/top10_moving_companies_in_canada": {
    title: "Top 10 Moving Companies in Canada | Moving Guide",
    description:
      "Review key factors to consider when comparing top moving companies in Canada for local and long-distance relocation.",
    keywords:
      "top moving companies Canada, top 10 movers Canada, best movers Canada, moving company comparison",
  },
  "/do_moving_company_unbox_boxes_and_arrange_household_items": {
    title: "Do Moving Companies Unbox and Arrange Household Items?",
    description:
      "Learn whether moving companies help unpack boxes, arrange household items, and provide add-on services after delivery.",
    keywords:
      "do movers unpack boxes, moving company unpacking, household item arrangement, unpacking services Canada",
  },
};

const cityLandingPages = [
  ["/mover-in-edmonton", "Edmonton"],
  ["/movers-in-calgary", "Calgary"],
  ["/movers-in-montreal", "Montreal"],
  ["/movers-in-vancouver", "Vancouver"],
  ["/movers-in-winnipeg", "Winnipeg"],
  ["/movers-in-halifax", "Halifax"],
  ["/movers-in-moncton", "Moncton"],
  ["/movers-in-ottawa", "Ottawa"],
  ["/movers-in-toronto", "Toronto"],
  ["/movers-in-victoria", "Victoria"],
  ["/movers-in-newfoundland-and-labrador", "Newfoundland and Labrador"],
  ["/movers-in-alberta", "Alberta"],
  ["/movers-in-red-deer", "Red Deer"],
  ["/movers-in-medicine-hat", "Medicine Hat"],
  ["/movers-in-saskatchewan", "Saskatchewan"],
  ["/movers-in-lloydminster", "Lloydminster"],
  ["/movers-in-grande-prairie", "Grande Prairie"],
  ["/movers-in-camrose", "Camrose"],
  ["/movers-in-lethbridge", "Lethbridge"],
  ["/movers-in-fort-mcmurray", "Fort McMurray"],
  ["/movers-in-british-columbia", "British Columbia"],
  ["/movers-in-nunavut", "Nunavut"],
  ["/movers-in-manitoba", "Manitoba"],
  ["/movers-in-hamilton", "Hamilton"],
  ["/movers-in-thunder-bay", "Thunder Bay"],
  ["/movers-in-kingston", "Kingston"],
  ["/movers-in-quebec-city", "Quebec City"],
  ["/movers-in-greater-sudbury", "Greater Sudbury"],
  ["/movers-in-brampton", "Brampton"],
  ["/movers-in-new-brunswick", "New Brunswick"],
  ["/movers-in-nova-scotia", "Nova Scotia"],
  ["/movers-in-north-york", "North York"],
];

const citySeo = cityLandingPages.reduce((seo, [path, city]) => {
  seo[path] = {
    title: `Movers in ${city} | GO MOVE CANADA`,
    description: `Hire professional movers in ${city} for local and long-distance moving, packing, storage, and relocation support from GO MOVE CANADA.`,
    keywords: `movers in ${city}, moving company ${city}, ${city} movers, local movers ${city}, long distance movers ${city}`,
  };

  return seo;
}, {});

const citySeoOverrides = {
  
  "/movers-in-calgary": {
    title: "Affordable Movers in Calgary | Go Move Canada",
    description:
      "Need affordable movers in Calgary? Go Move Canada offers trusted local and long-distance moving services with transparent pricing. Get a free quote today.",
  },
  "/movers-in-ottawa": {
    title: "Affordable Movers in Ottawa | Go Move Canada",
    description:
      "Looking for trusted movers in Ottawa? Go Move Canada offers affordable local and long-distance moving services with professional crews and transparent pricing. Get a free quote today.",
  },
  "/movers-in-toronto": {
    title: "Affordable Movers in Toronto | Go Move Canada",
    description:
      "Looking for trusted movers in Toronto? Go Move Canada offers affordable local and long-distance moving services with professional crews and transparent pricing. Get a free quote today.",
  },
  "/movers-in-alberta": {
    title: "Affordable Movers in Alberta | Go Move Canada",
    description:
      "Looking for trusted movers in Alberta? Go Move Canada provides affordable local and long-distance moving services with transparent pricing and professional crews. Get a free quote today.",
  },
  "/mover-in-edmonton": {
    title: "Affordable Movers in Edmonton | Go Move Canada",
    description:
      "Looking for affordable movers in Edmonton? Go Move Canada offers trusted local and long-distance moving services with transparent pricing. Get a free quote today.",
  },
};

const pageSeo = {
  ...servicePages,
  ...citySeo,
  ...Object.keys(citySeoOverrides).reduce((seo, path) => {
    seo[path] = {
      ...citySeo[path],
      ...citySeoOverrides[path],
    };

    return seo;
  }, {}),
};

const normalizePath = (pathname) => {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
};

export const getSeoForPath = (pathname) => {
  const path = normalizePath(pathname);
  return {
    ...defaultSeo,
    ...(pageSeo[path] || {}),
    path,
  };
};

const PageSeo = () => {
  const location = useLocation();
  const seo = getSeoForPath(location.pathname);
  const canonicalPath = seo.path === "/" ? "/" : `${seo.path}/`;
  const canonicalUrl = `${siteUrl}${canonicalPath}`;
  const pageFaqs = getFaqsForPath(seo.path);
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: pageFaqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

   const skipMetaTags = pagesWithOwnMetaTags.includes(seo.path);

  return (
    <Helmet>
       {!skipMetaTags && <title>{seo.title}</title>}
      {!skipMetaTags && <meta name="description" content={seo.description} />}
      {/* <title>{seo.title}</title>
      <meta name="description" content={seo.description} /> */}
      <meta name="keywords" content={seo.keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content="website" />
       {!skipMetaTags && <meta property="og:title" content={seo.title} />}
      {!skipMetaTags && (
        <meta property="og:description" content={seo.description} />
      )}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
       {!skipMetaTags && <meta name="twitter:title" content={seo.title} />}
      {!skipMetaTags && (
        <meta name="twitter:description" content={seo.description} />
      )}
      <script id="faq-schema" type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default PageSeo;
